import { Box, Button } from "@mui/material";
import React from "react";

import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded";

import { IPageLayoutType } from "../../types/pageLayoutTypes";
import DynamicPageLayout from "../common/DynamicPageLayout";

const AssessmentDetails: React.FunctionComponent<any> = (props: any) => {
  const assessmentDetailsContentJson: IPageLayoutType[] = [
    {
      title: "Mutation status for study eligibility",
      description: "",
      content: [
        {
          label: "Sample Type",
          value: "Archival tumor tissue",
          size: {
            mediumScreen: 12,
            extraSmallScreen: 12,
          },
        },
        {
          label: "Collection Time",
          value: "Archived",
          size: {
            mediumScreen: 12,
            extraSmallScreen: 12,
          },
        },
        {
          label: "Collection Location",
          value: "TBD",
          size: {
            mediumScreen: 12,
            extraSmallScreen: 12,
          },
        },
        {
          label: "Test Kit",
          value: "Yes",
          size: {
            mediumScreen: 12,
            extraSmallScreen: 12,
          },
        },
        {
          label: "Test kit instruction",
          value:
            "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English.",
          size: {
            mediumScreen: 12,
            extraSmallScreen: 12,
          },
        },
        {
          label: "Tester",
          value: "Selected from Site, Central Lab, and Vendor",
          size: {
            mediumScreen: 12,
            extraSmallScreen: 12,
          },
        },
      ],
    },
  ];

  return (
    <>
      <Box className="backBtnWrap">
        <Button
          startIcon={<ArrowBackIosNewRoundedIcon />}
          size="small"
          onClick={() => props.setDetailsPage(false)}
        >
          Back
        </Button>
      </Box>

      <DynamicPageLayout
        pageContentJson={assessmentDetailsContentJson}
        data={{}}
      />
    </>
  );
};

export default AssessmentDetails;
